import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/global.css";

// Prevent console errors on mobile devices
const handleGlobalError = (event) => {
  // Prevent ethereum/web3 related errors
  if (event.message?.includes("ethereum") || event.message?.includes("web3")) {
    event.preventDefault();
    return;
  }

  // Prevent script errors without details (common in mobile browsers)
  if (event.message === "Script error." && !event.error) {
    event.preventDefault();
    return;
  }
};

// Add error event listeners
window.addEventListener("error", handleGlobalError, true);
window.addEventListener("unhandledrejection", (event) => {
  if (event.reason?.message?.includes("ethereum")) {
    event.preventDefault();
  }
});

// Safe ethereum mock
const ethereumMock = {
  selectedAddress: null,
  isMetaMask: false,
  request: () => Promise.resolve(null),
  on: () => {},
  removeListener: () => {},
};

// Safely set ethereum mock
Object.defineProperty(window, "ethereum", {
  value: ethereumMock,
  writable: false,
  configurable: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
